import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = {
  class: "dialog_content",
  style: {"overflow":"hidden"}
}
const _hoisted_4 = { class: "field-group q-mt-sm" }
const _hoisted_5 = {
  class: "row no-wrap",
  style: {"align-items":"baseline"}
}
const _hoisted_6 = { class: "field-group q-mt-sm" }
const _hoisted_7 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_8 = { class: "bold-name mr-xs" }
const _hoisted_9 = { class: "field-group q-mt-sm" }
const _hoisted_10 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_11 = { class: "bold-name mr-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_selector_popup = _resolveComponent("selector-popup")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "inhdialog-container-narrow" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('warehouse_information')), 1),
        _createVNode(_component_q_btn, {
          flat: "",
          round: "",
          icon: "close",
          size: "md",
          color: "accent",
          title: _ctx.$t('close_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_native_input, {
              ref: "storage_name_input",
              "allow-line-break": false,
              "model-value": _ctx.storageNameDraft,
              "onUpdate:modelValue": _ctx.onStorageNameInput
            }, null, 8, ["model-value", "onUpdate:modelValue"]),
            (_ctx.currentStorage && _ctx.CanWrite)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  flat: "",
                  dense: "",
                  round: "",
                  size: "xs",
                  icon: "edit",
                  color: "grey-6",
                  class: "q-ml-xs",
                  style: {"margin-top":"2px"},
                  onClick: _withModifiers(_ctx.focusInput, ["stop"])
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('responsible_worker')) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.selectedExistingResponsible ? _ctx.selectedExistingResponsible.Name : _ctx.currentStorage?.ResponsibleWorker?.Name), 1),
            _createVNode(_component_q_btn, {
              ref: "respMenuTrigger",
              disable: !_ctx.CanWrite,
              "no-caps": "",
              label: _ctx.$t('change_responsible'),
              flat: "",
              onClick: _withModifiers(_ctx.handleMenuShow, ["stop"])
            }, null, 8, ["disable", "label", "onClick"]),
            (_ctx.CanWrite)
              ? (_openBlock(), _createBlock(_component_selector_popup, {
                  key: 0,
                  visible: _ctx.showSelector,
                  "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showSelector) = $event)),
                  "trigger-el": _ctx.$refs.respMenuTrigger,
                  "wide-layout": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_aux_selector, {
                      ref: "aux-selector",
                      modelValue: _ctx.tmp_resp,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tmp_resp) = $event)),
                      "model-type": 3,
                      "limit-height-to-container": true,
                      "hide-checkboxes": true,
                      "allow-multiple": true,
                      onSelectorClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSelector = false))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["visible", "trigger-el"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('warehouse_group')) + ": ", 1),
            _createVNode(_component_q_select, {
              disable: !_ctx.CanWrite,
              flat: "",
              "model-value": _ctx.currentStorageGroupId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = (arg) => {
              _ctx.changeStorageGroup(arg);
              _ctx.currentStorageGroupId = arg;
            }),
              style: {"min-width":"150px"},
              class: "thin-input q-mr-xs",
              "dropdown-icon": "expand_more",
              "fill-input": "",
              "bottom-slots": false,
              dense: "",
              outlined: "",
              "input-debounce": "500",
              "emit-value": "",
              "map-options": "",
              "option-label": "Name",
              "option-value": "Id",
              ref: "from_select",
              options: _ctx.storageGroups
            }, null, 8, ["disable", "model-value", "options"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}